export default {
  LOT_CARD: 'lot_card',
}
